import React from 'react'
import { createRoot } from 'react-dom/client'
import axios from 'axios'

import App from './App'
import { addNoCacheParam } from './utils/utils'

import './assets/styles/app.scss'

addNoCacheParam(axios)
const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App />)
